import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { CompaniesService } from '@services/companies.service';
import { UntypedFormGroup } from '@angular/forms';
import { CompanyModel } from '@data-layer/models/companies';
import { CUSTOM_MASK } from '@helpers/custom-validator';
import { CountryModel, CurrencyModel, IncoTermModel } from '@data-layer/models/common';
import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { CodeRepository } from '@data-layer/repositories';

@Component({
  selector: 'es-details-invoice-card-form-desktop',
  templateUrl: './es-details-invoice-card-form-desktop.component.html',
  styleUrls: ['./es-details-invoice-card-form-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsDetailsInvoiceCardFormDesktopComponent implements OnInit, OnDestroy {
  @Input() public fg: UntypedFormGroup;
  @Input() public billOfLadingId: number;
  @Input() public currencies: CurrencyModel[] = [];
  @Input() public currencyRate: number = 1;
  @Input() public incoterms: IncoTermModel[] = [];

  public company: CompanyModel;
  public errors: { [name: string]: string } = {
    required: 'FORM_ERROR.REQUIRED',
    invoiceNumberMatch: 'FORM_ERROR.INVOICE_NUMBER_MATCH',
    maxlength: 'FORM_ERROR.MAX_LENGTH',
    currencyIsNotAvailable: 'BACK_ERROR.CURRENCY_IS_NOT_AVAILABLE',
  };
  public CUSTOM_MASK: typeof CUSTOM_MASK = CUSTOM_MASK;
  public DEFAULT_CURRENCY_CODE: string = DEFAULT_CURRENCY_CODE;
  public initCountryOfExportItems: CountryModel[] = [];

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private companiesService: CompaniesService, private codeRepository: CodeRepository) {}

  public ngOnInit(): void {
    this.company = this.companiesService.getCompany();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public searchInvoice(term: string, item: IncoTermModel): boolean {
    term = term.toLowerCase().trim();
    return item.code.toLowerCase().indexOf(term) > -1 || item.name.toLowerCase().indexOf(term) > -1;
  }

  public getCountries(): Observable<CountryModel[]> {
    return this.codeRepository.searchCountry.bind(this.codeRepository);
  }

  public onCountryOfExportChange(country: CountryModel | undefined): void {
    this.initCountryOfExportItems = country != null ? [country] : [];
  }

  public get isDetailsValid(): boolean {
    return this.fg.get('invoiceNumber').valid && this.fg.get('currency').valid;
  }

  public get currencyHasRateError(): boolean {
    return isNaN(this.currencyRate);
  }
}
